import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = sanityClient({
  projectId:"e45kkjpw",
  dataset: 'production',
  apiVersion: '2022-02-01', 
  useCdn: true,
  token: "skfsr7SzQm0lKN6Mmc9SMqpdxt6SyimO89hwqdir5tQEoDhcSjEx1qd2rzfyYL7Gyl9hxGaQTjMZUHUuwEYf0vlmIr6rcNz4mgYT2EHDVX1QMZgVy3PuKfk6mh7WSTNaukemrgYvylVX24CQQ0u1VldF0rqYel1VlamsN8rPd0NivKnJoMFH",
});

const builder = imageUrlBuilder(client);

export const urlFor = (source) => builder.image(source);